import React from 'react';
import { ToursCardElement } from './ToursCardElement';

export const ToursCardList = ({ items = [] }) => {

    return (
        <>
            {
                items.map((item, index) => {

                    return (
                        <ToursCardElement key={'tour_' + (index + 1)} {...item} />
                    )

                })
            }
        </>
    );
};
